import './style.css';
import { render } from './ui/render.js';

const screen = document.getElementById('screen');
if (!(screen instanceof HTMLElement)) {
  throw new Error('#screen is missing from index.html');
}

render(screen, {
  title: 'Videophone',
  status: 'Foundation — step 1 of 13',
  lines: [
    'Vite · strict TypeScript · Vitest · Playwright · plain DOM',
    'No call engine yet. See docs/development-plan.md for the agreed plan.',
    'Next: hosted HTTPS origin (step 2), then the KVS risk spike (step 3).',
  ],
});

// Input is handled at document level, never via focused controls, because a
// full re-render destroys focus. See docs/development-plan.md §3.2 rule 3.
// The real InputSource seam and the F13-F18 mappings arrive at step 5.
document.addEventListener('keydown', (event: KeyboardEvent) => {
  if (event.repeat) return;
  console.debug('[input] keydown', event.code);
});
